/**
 Copyright (C) 2022 北大英华版权所有。 
  
  文件名：系统设置 接口
  文件功能描述：接口
  
  创建标识：zhangjiaojiao0829
  
  修改标识：
  修改描述：
*/
 

// 统一请求路径前缀在libs/axios.js中修改
import { getRequest,getRequestLinux,postRequest,postRequest2 } from '@/libs/request';
// const authorGateway = 'gdzf-auth/';// 用户
// const authorGateway = 'gdzf-law-auth/';// 用户
const authorGateway = '/';// 用户

// const standGateway = ''
// const standGateway = 'law-admin/'
const standGateway = '/'
// 内容管理列表
export const postManagList = (params) => {
    return postRequest('/regulatory/docs/list',params)
}
// 内容管理录入
export const managEntry = (params) => {
    return postRequest('/regulatory/docs/addOrUpdate',params)
}
// 标题检索
// export const getSearchtitle = (params) => {
//     return getRequestLinux('/helpcenter/search',params,'lin')
// }
//  个人资料------
// 退出登录
export const logOut = (params) => {
    return getRequest(authorGateway + 'logout', params)
}
// 个人资料
export const getUser = (params) => {
    return getRequest(authorGateway + 'user/info', params)
}
// 登录
export const login = (params) => {
    return postRequest2(authorGateway + 'login', params)
}
// 法规前台用户登录权限
export const getPermission = (params) => {
    return getRequest(authorGateway + 'permission/user-permission', params)
}
